<template>
  <div class="crm-page">
    <div class="crm-wrapper">
      <!-- HEADER -->
      <div class="page-header mb-4">
        <div class="d-flex align-items-center">
          <div class="header-icon">
            <i class="fa fa-headphones"></i>
          </div>
          <div>
            <h2 class="header-title mb-0">Quản lý cuộc gọi khách hàng</h2>
          </div>
        </div>
      </div>

      <div class="row g-4">
        <!-- LEFT SIDEBAR -->
        <div class="col-lg-4 col-xl-3" v-if="taskInfo">
          <!-- CUSTOMER INFO -->
          <div class="info-card mb-3">
            <div class="card-header-custom">
              <i class="fa fa-user mr-2"></i>
              <h6 class="mb-0">Thông tin khách hàng</h6>
            </div>
            <div class="card-body-custom">
              <div class="customer-name mb-3">
                <div class="avatar-circle-small">
                  <i class="fa fa-user"></i>
                </div>
                <div class="customer-name-text">
                  {{ taskInfo.full_name }}
                </div>
              </div>

              <div class="info-item">
                <i class="fa fa-phone text-primary"></i>
                <span
                  class="phone-number"
                >
                  {{ taskInfo.phone_number }}
                </span>
              </div>

              <div class="info-item">
                <i class="fa fa-map-marker text-primary"></i>
                <span>{{ taskInfo.address || 'Chưa cập nhật địa chỉ' }}</span>
              </div>

              <button
                class="btn btn-primary btn-custom w-100 mt-3"
                :disabled="inProgress"
                @click="openVerifyModal"
              >
                <i class="fa fa-search mr-2"></i>
                Kiểm tra đơn hàng
              </button>
            </div>
          </div>

          <!-- EXTRA INFO -->
          <div class="info-card" v-if="hasExtraInfo">
            <div class="card-header-custom">
              <i class="fa fa-info-circle mr-2"></i>
              <h6 class="mb-0">Thông tin đăng ký</h6>
            </div>
            <div class="card-body-custom">
              <div v-if="taskInfo.order_original_duration" class="extra-info-item">
                <span class="label">Thời hạn gói:</span>
                <strong>{{ taskInfo.order_original_duration }} tháng</strong>
              </div>

              <div v-if="taskInfo.order_device_type_name" class="extra-info-item">
                <span class="label">Thiết bị:</span>
                <strong>{{ taskInfo.order_device_type_name }}</strong>
              </div>

              <div v-if="taskInfo.qrpaybox_created_at" class="extra-info-item">
                <span class="label">Đăng ký tài khoản:</span>
                <span>{{ formatDate(taskInfo.qrpaybox_created_at) }}</span>
              </div>

              <div v-if="taskInfo.order_created_at" class="extra-info-item">
                <span class="label">Ngày tạo đơn:</span>
                <span>{{ formatDate(taskInfo.order_created_at) }}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- RIGHT CONTENT -->
        <div class="col-lg-8 col-xl-9">
          <!-- NOTE SECTION -->
          <div class="info-card mb-4" v-if="taskInfo">
            <div class="card-header-custom">
              <i class="fa fa-edit mr-2"></i>
              <h6 class="mb-0">Ghi chú cuộc gọi</h6>
              <span class="badge-optional ml-auto">Bắt buộc</span>
            </div>
            <div class="card-body-custom">
              <textarea
                v-model="note"
                class="form-control form-control-custom"
                rows="4"
                maxlength="500"
                placeholder="Nhập nội dung trao đổi / nhu cầu khách hàng..."
              ></textarea>
              <div class="char-count">
                {{ note.length }}/500 ký tự
              </div>
            </div>
          </div>

          <!-- CALL RESULT -->
          <div class="info-card">
            <div class="card-header-custom">
              <i class="fa fa-check-circle mr-2"></i>
              <h6 class="mb-0">Kết quả cuộc gọi</h6>
            </div>
            <div class="card-body-custom">
              <div class="call-action-grid">
                <button
                  v-for="btn in statusButtons"
                  :key="btn.status"
                  class="call-action-btn"
                  :class="btn.class"
                  :disabled="!taskInfo || inProgress || !note.trim()"
                  @click="updateTaskStatus(btn.status)"
                >
                  <i :class="btn.icon" class="mr-2"></i>
                  {{ btn.label }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- VERIFY MODAL -->
      <b-modal
        id="verify-order-modal"
        title="Kiểm tra đơn hàng"
        centered
        hide-footer
      >
        <p class="mb-4">Bạn có chắc chắn muốn kiểm tra đơn hàng của khách hàng này?</p>
        <div class="d-flex justify-content-end gap-2">
          <button
            class="btn btn-outline-secondary btn-custom"
            @click="$bvModal.hide('verify-order-modal')"
          >
            Huỷ
          </button>
          <button
            class="btn btn-primary btn-custom"
            :disabled="inProgress"
            @click="confirmVerifyOrder"
          >
            <i class="fa fa-check mr-2"></i>
            Kiểm tra
          </button>
        </div>
      </b-modal>

      <!-- OVERLAY -->
      <div v-if="inProgress" class="crm-overlay">
        <div class="spinner-border text-primary"></div>
        <div class="mt-3 fw-bold">Đang xử lý...</div>
      </div>
    </div>
  </div>
</template>

<script>
import apiClient from "@/axios";

export default {
  data() {
    return {
      taskInfo: null,
      note: "",
      inProgress: false,
      currentRequestId: 0,
      customerOrderIdInput: "",
      showPhoneMenu: false,
      menuX: 0,
      menuY: 0,
      selectedPhone: "",
      statusButtons: [
        {
          status: 1,
          label: "Đồng ý",
          class: "btn-success",
          icon: "fa fa-check-circle"
        },
        {
          status: 5,
          label: "Cần tư vấn thêm",
          class: "btn-info",
          icon: "fa fa-comments"
        },
        {
          status: 2,
          label: "Từ chối",
          class: "btn-danger",
          icon: "fa fa-times-circle"
        },
        {
          status: 3,
          label: "Không nghe",
          class: "btn-warning",
          icon: "fa fa-ban"
        },
        {
          status: 4,
          label: "Thuê bao",
          class: "btn-secondary",
          icon: "fa fa-ban"
        },
      ],
    };
  },

  computed: {
    hasExtraInfo() {
      const t = this.taskInfo;
      return !!(
        t?.qrpaybox_created_at ||
        t?.order_original_duration ||
        t?.order_device_type_name ||
        t?.order_created_at
      );
    },
  },

  mounted() {
    this.getTask();
  },

  methods: {
    toast(title, message, variant = "default") {
      this.$bvToast.toast(message, {
        title,
        variant,
        solid: true,
        autoHideDelay: 3000,
      });
    },

    formatDate(value) {
      return value ? value.replace(" ", " • ") : "";
    },

    async getTask() {
      const requestId = Date.now();
      this.currentRequestId = requestId;

      this.taskInfo = null;
      this.note = "";

      try {
        const res = await apiClient.get("/api/v1/sale/task", {
          params: {
            _t: Date.now()
          },
          headers: {
            'Cache-Control': 'no-cache, no-store, must-revalidate',
            'Pragma': 'no-cache'
          }
        });

        if (requestId === this.currentRequestId) {
          this.taskInfo = res?.data || null;
        }
      } catch (error) {
        if (requestId === this.currentRequestId) {
          console.error('Get task error:', error);
          this.taskInfo = null;
          if (this.toast) {
            this.toast(
              "Lỗi",
              error?.response?.data?.message || "Không thể tải thông tin khách hàng",
              "danger"
            );
          }
        }
      }
    },

    openVerifyModal() {
      this.$bvModal.show("verify-order-modal");
    },

    async confirmVerifyOrder() {
      this.inProgress = true;
      try {
        const payload = {
          orders: [
            {
              assignmentId: this.taskInfo.assignment_id
            }
          ]
        }
        const res = await apiClient.post(
          "/api/v1/sale/assignment/customer-order", payload
        );

        this.toast("Thành công", res?.data?.message || "Kiểm tra đơn hàng thành công", "success");
        this.$bvModal.hide("verify-order-modal");
      } catch (error) {
        this.toast(
          "Lỗi",
          error?.response?.data?.message || "Không thể kiểm tra đơn hàng",
          "danger"
        );
        this.$bvModal.hide("verify-order-modal");
      } finally {
        this.inProgress = false;
      }
    },

    async updateTaskStatus(status) {
      if (!this.taskInfo) return;

      this.inProgress = true;
      try {
        const payload = {
          assignmentId: String(this.taskInfo.assignment_id),
          customerId: String(this.taskInfo.customer_id),
          status,
          note: this.note.trim(),
        };
        await apiClient.post("/api/v1/sale/update-task", payload);
        this.toast("Thành công", "Cập nhật trạng thái cuộc gọi thành công", "success");
        await this.getTask();
      } catch (error) {
        this.toast(
          "Lỗi",
          error?.response?.data?.message || "Không thể cập nhật trạng thái",
          "danger"
        );
      } finally {
        this.inProgress = false;
      }
    },

    onRightClickPhone(event, phone) {
      this.selectedPhone = phone;
      this.menuX = event.clientX;
      this.menuY = event.clientY;
      this.showPhoneMenu = true;
      document.addEventListener("click", this.hidePhoneMenu);
    },

    hidePhoneMenu() {
      this.showPhoneMenu = false;
      document.removeEventListener("click", this.hidePhoneMenu);
    },
  },
};
</script>

<style scoped>
.crm-page {
  min-height: 100vh;
  padding: 30px 20px;
}

.crm-wrapper {
  max-width: 1400px;
  margin: 0 auto;
}

/* Page Header */
.page-header {
  background: white;
  padding: 24px;
  border-radius: 12px;
  box-shadow: 0 2px 8px #ddd;
  border: 1px solid #e9ecef;
}

.header-icon {
  width: 50px;
  height: 50px;
  border-radius: 12px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  color: white;
  margin-right: 16px;
}

.header-title {
  font-size: 22px;
  font-weight: 700;
  color: #212529;
}

.header-subtitle {
  font-size: 14px;
  color: #6c757d;
  margin-top: 4px;
}

/* Info Card */
.info-card {
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 8px #ddd;
  border: 1px solid #e9ecef;
  overflow: hidden;
}

.card-header-custom {
  padding: 16px 20px;
  background: #f8f9fa;
  border-bottom: 1px solid #e9ecef;
  display: flex;
  align-items: center;
}

.card-header-custom i {
  font-size: 16px;
  color: #007bff;
}

.card-header-custom h6 {
  font-weight: 600;
  color: #212529;
  font-size: 15px;
}

.badge-optional {
  background: #e9ecef;
  color: #6c757d;
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
}

.card-body-custom {
  padding: 20px;
}

/* Customer Info */
.customer-name {
  display: flex;
  align-items: center;
  gap: 12px;
}

.avatar-circle-small {
  width: 45px;
  height: 45px;
  border-radius: 50%;
  background: #e9ecef;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  color: #6c757d;
}

.customer-name-text {
  font-size: 18px;
  font-weight: 700;
  color: #212529;
}

.info-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 0;
  border-bottom: 1px solid #f1f3f5;
  font-size: 14px;
  color: #495057;
}

.info-item:last-child {
  border-bottom: none;
}

.info-item i {
  font-size: 14px;
  width: 16px;
}

.phone-number {
  cursor: context-menu;
  user-select: text;
  font-weight: 500;
}

/* Extra Info */
.extra-info-item {
  display: flex;
  justify-content: space-between;
  padding: 8px 0;
  font-size: 13px;
  border-bottom: 1px solid #f1f3f5;
}

.extra-info-item:last-child {
  border-bottom: none;
}

.extra-info-item .label {
  color: #6c757d;
}

.extra-info-item strong {
  color: #212529;
}

/* Form Controls */
.form-control-custom {
  border-radius: 8px;
  border: 1px solid #dee2e6;
  padding: 10px 14px;
  font-size: 14px;
  resize: none;
}

.form-control-custom:focus {
  border-color: #007bff;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.15);
}

.char-count {
  text-align: right;
  font-size: 12px;
  color: #6c757d;
  margin-top: 8px;
}

/* Call Action Grid */
.call-action-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 12px;
}

.call-action-btn {
  padding: 14px 20px;
  border-radius: 8px;
  font-weight: 600;
  font-size: 14px;
  border: none;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.call-action-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.call-action-btn i {
  font-size: 16px;
}

.btn-success {
  background: #28a745;
}

.btn-success:hover:not(:disabled) {
  background: #218838;
}

.btn-info {
  background: #17a2b8;
}

.btn-info:hover:not(:disabled) {
  background: #138496;
}

.btn-danger {
  background: #dc3545;
}

.btn-danger:hover:not(:disabled) {
  background: #c82333;
}

.btn-warning {
  background: #ffc107;
  color: #212529;
}

.btn-warning:hover:not(:disabled) {
  background: #e0a800;
}

.btn-secondary {
  background: #6c757d;
}

.btn-secondary:hover:not(:disabled) {
  background: #5a6268;
}

/* Buttons */
.btn-custom {
  padding: 10px 24px;
  border-radius: 8px;
  font-weight: 600;
  font-size: 14px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

/* Overlay */
.crm-overlay {
  position: fixed;
  inset: 0;
  background: rgba(255, 255, 255, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  z-index: 9999;
}

/* Phone Context Menu */
.phone-context-menu {
  position: fixed;
  background: white;
  border: 1px solid #dee2e6;
  border-radius: 8px;
  min-width: 160px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 10000;
}

.menu-item {
  padding: 12px 16px;
  cursor: pointer;
  font-size: 14px;
  color: #212529;
  display: flex;
  align-items: center;
}

.menu-item:hover {
  background: #f8f9fa;
}

.menu-item i {
  font-size: 14px;
}

/* Responsive */
@media (max-width: 992px) {
  .call-action-grid {
    grid-template-columns: 1fr 1fr;
  }
}

@media (max-width: 576px) {
  .crm-page {
    padding: 20px 12px;
  }

  .call-action-grid {
    grid-template-columns: 1fr;
  }
}
</style>
